// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.title[data-v-a01ffa02] {\n  font-size: 16px;\n  padding: 10px 0;\n}\n.img-wrap[data-v-a01ffa02] {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n}\n.img-content[data-v-a01ffa02]{\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n", ""]);
// Exports
module.exports = exports;
